<template>
	<div>
		<form-dropdown
			v-if="requestTypes"
			:items="requestTypes"
			:selected="current"
			:label="showLabel ? (label ? label : 'Misc.RequestType') : ''"
			name="requestType"
			input-updated-event-name="request-type-input-updated-event"
			component-class="form-inline-box"
		></form-dropdown>
		<span style="display: none">{{ selected }}</span>
	</div>
</template>

<script>
import FormDropdown from '@/components/atoms/FormDropdown'
import ServiceHelper from '@/mixins/ServiceHelper'

export default {
	name: 'RequestTypeSelector',
	components: {
		FormDropdown,
	},
	mixins: [ServiceHelper],
	props: {
		selected: {
			type: [String, Number],
			default: '',
		},
		showLabel: {
			type: Boolean,
			default: true,
		},
		label: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			current: '',
			requestTypes: null,
		}
	},
	mounted() {
		// Retrieve current data from provided value or store
		this.current = this.selected ? this.selected : this.$store.state.misc.requestType

		// Listen for request type input updated event
		this.$root.$on('request-type-input-updated-event', (result) => {
			this.current = result.value
			this.$store.commit('setRequestType', { requestType: result.value })
		})
	},
	created() {
		if (sessionStorage.getItem('ius_request_types')) {
			// If available, use session storage request types
			this.requestTypes = JSON.parse(sessionStorage.getItem('ius_request_types'))
		} else {
			// Retrieve request types from API and store in session storage
			this.loadData()
		}
	},
	methods: {
		loadData() {
			// Get data
			axios
				.get('/request-types', {
					params: this.loadAllParams,
				})
				.then((response) => {
					this.requestTypes = response.data.info
					sessionStorage.setItem('ius_request_types', JSON.stringify(this.requestTypes))
				})
				.catch((error) => {
					console.log(error)
				})
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/utils/commons/RequestTypeSelector.vue